import React from "react";

import PropTypes from "prop-types";
import getTooltip from "Utils/getTooltip";

import { BodyMedium } from "Cobalt/BodyText";
import { Popover } from "Cobalt/Popover";
import SIOverlayTrigger from "Common/SIOverlayTrigger";

type Props = {
  text: string;
  term: string;
};

export default function HeaderWithTooltip({ text, term }: Props) {
  const planKeyPopover = (
    <Popover showBackdrop={false} id={term}>
      {getTooltip(term)}
    </Popover>
  );
  return (
    <SIOverlayTrigger placement="bottom" overlay={planKeyPopover}>
      <BodyMedium>{text}</BodyMedium>
    </SIOverlayTrigger>
  );
}

HeaderWithTooltip.propTypes = {
  text: PropTypes.string,
  term: PropTypes.string,
};
